var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "layout_icon__1cBt5 layout_iconShadow__1_5UW",
    width: 20,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M0,0H20V15H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "b",
    d: "M2.344,0,9.969,5.656,17.563,0H20V1.938L12.5,7.531,20,13.094V15H17.5L10,9.406,2.531,15H0V13.125L7.469,7.563,0,2V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "c",
    d: "M13.25,8.781,20,13.75V15L11.531,8.781ZM7.5,9.406,7.688,10.5l-6,4.5H0ZM20,0V.094L12.219,5.969l.063-1.375L18.438,0ZM0,0,7.469,5.5H5.594L0,1.313Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "b",
    d: "M7.531,0V15h5V0ZM0,5v5H20V5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "c",
    d: "M0,6.031v3H20v-3ZM8.531,0V15h3V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/englishFlag.f28373ab0bf7c74b43eae355d631d1db.svg";
export { ForwardRef as ReactComponent };